/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Survey-Medallia Component: Load external js-script after delay
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { useEffect } from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectAuthSurvey } from '../../pages/PageAuth/selectors/authSelectors';
import { IAuthSurvey } from '../../pages/PageAuth/types/authTypes';
import { IRootReducer } from '../../reducers/rootReducer';
import { AccessComponentKeyEnum } from '../role/constants/guard/guardConstants';
import { makeSelectGuardComponentEnabled } from '../role/selectors/guardSelector';

const SURVEY_NODE_ID = 'survey-script';

const SurveyMedallia = (props: IConnectedProps) => {

    const {
        isEnabled,
        survey,
    } = props;

    useEffect(() => {
        if (!isEnabled || !survey?.url) return;

        const script = document.createElement('script');
        script.src = survey.url;
        script.id = SURVEY_NODE_ID;
        script.async = true;
        window.medalliaInnerSegmentId = survey.innerSegmentId;
        window.medalliaAccessLevelId = survey.sacsId;

        const timer = setTimeout(() => {
            document.body.appendChild(script);
        }, (survey.scriptLoadingDelay || 0) * 1000);
        return () => {
            clearTimeout(timer);
            document.getElementById(SURVEY_NODE_ID)?.remove();
        };
    }, [isEnabled, survey]);

    return null;
};

interface IConnectedProps {
    isEnabled: boolean;
    survey: IAuthSurvey | undefined;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    isEnabled: makeSelectGuardComponentEnabled(AccessComponentKeyEnum.surveyMedallia),
    survey: makeSelectAuthSurvey(),
});

export default connect(mapStateToProps)(SurveyMedallia);
